(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[732],{

/***/ "J4hE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Plus", function() { return Plus; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Plus = function Plus(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 30 30"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    d: "M25.3057895,13.3063638 L16.6932119,13.3080781 L16.6914976,4.69212335 C16.6914976,4.2395516 16.5149261,3.81612273 16.1960687,3.49726536 C15.8772113,3.1766937 15.4520682,3.00012214 14.9977821,3.00012214 C14.06521,3.00183643 13.3057809,3.76126554 13.3057809,4.69383764 L13.3057809,13.3080781 L4.68807763,13.3080781 C4.23893446,13.3080781 3.81550558,13.4846496 3.49493393,13.803507 C3.17607655,14.1240787 2.999505,14.5492218 2.999505,14.998365 C2.999505,15.452651 3.17607655,15.8777942 3.49493393,16.1966516 C3.81550558,16.5172232 4.23893446,16.6937948 4.6932205,16.6937948 L13.3057809,16.6937948 L13.3057809,25.3080866 C13.3057809,26.2389445 14.0669243,26.9983736 14.999505,27.0000879 C15.4520682,27.0000879 15.8772113,26.8252306 16.197783,26.5063732 C16.5166404,26.1858016 16.6932119,25.7606584 16.6914976,25.3098009 L16.6932119,16.6937948 L25.3057895,16.6937948 C25.7600755,16.6920805 26.1852187,16.5172232 26.5040761,16.1983659 C26.8229334,15.8795085 26.9977907,15.452651 26.999505,14.9966507 C26.9977907,14.0657929 26.2383616,13.3063638 25.3057895,13.3063638"
  }));
};

/***/ })

}]);